// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"2":"9b7de447","17":"41736bc2","136":"ea81506f","146":"fb268d1f","166":"931f6153","259":"ad4ec65e","318":"869d8a96","335":"796b28f2","363":"13efbf58","403":"1c4583b1","407":"266669e8","415":"e4b991c8","448":"23dff8af","494":"3473df95","625":"1c5ed7ef","821":"9b0b087e"}[chunkId] + ".js";
};